import { Grid } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import { makeStyles } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { modalViewCotizadorAction, targetClienteAction } from "../../../ducks/cotizadorDuck";
import { addItemsAction, addAdultosAction, addMenoresAction, addMetodoPagoAction, addBancoAction, addBancoMensualidadAction, addIndividualAction } from "../../../ducks/cotizadorPaqueteDuck";
import CotizadorPaquete from "../CotizadorPaquete"
import { InitialValueCliente } from "../InitialCliente"

export const FCortizadorStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 0",
        padding: "1rem",
        overflowY: "scroll",
        maxHeight: "80vh"
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "99vw",
        minHeight: "99vh",
        maxWidth: "99vw",
        maxHeight: "99vh",
    },
}))

export const FCotizador = () => {
    const { modalCotizador } = useSelector(store => store.cotizador)
    const dispatch = useDispatch()
    const classes = FCortizadorStyle();
    const handleClose = () => {
        const autoComplete = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[2];
        if (autoComplete) {
            autoComplete.click()
        }
        const autoComplete2 = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
        if (autoComplete2) {
            autoComplete2.click()
        }
        dispatch(targetClienteAction({ cliente: InitialValueCliente, vista: 1, editar: false }))
        dispatch(modalViewCotizadorAction({ open: false }))
        dispatch(addItemsAction({listaItem: []}))
        dispatch(addAdultosAction({ cantidad: 0 }))
        dispatch(addMenoresAction({ cantidad: 0 }))
        dispatch(addMetodoPagoAction({metodoPago: "0"}))
        dispatch(addBancoAction({banco: "0"}))
        dispatch(addBancoMensualidadAction({banco: "0"}))
        dispatch(addIndividualAction({individual: "0"}))
    }
    return (
        <ModalBase classes={classes} open={modalCotizador} onClose={handleClose}>
            <HeaderModal handleClose={handleClose} titulo={`Nueva cotizacion`} />
            <Grid container className={classes.containerSpacing}>
                <CotizadorPaquete />
            </Grid>
        </ModalBase>
    )
}
export default FCotizador